import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import pl from "./locales/pl.json";

const resources = {
  en: { translation: en },
  pl: { translation: pl }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "pl", // Domyślny język
  fallbackLng: "pl",
  interpolation: {
    escapeValue: false // Nie eskapuj znaków HTML
  }
});

export default i18n;